module.exports = __webpack_public_path__ + "images/room.webp";